let url = $(location).attr('href').split("/").splice(0, 5).join("/");
let segments = url.split( '/' );
let lang = segments[3];
let two_segment = segments[4];
if('' === lang) {lang = 'ro';}

let urls = [];
urls['ro'] = 'cos';
urls['ru'] = 'korzina';

// Toast after product is added to cart (styles: app/css/style_main.scss, .cart-toast)
let addedToCartTexts = [];
addedToCartTexts['ro'] = 'Produsul a fost adăugat în coș';
addedToCartTexts['ru'] = 'Товар добавлен в корзину';

const CART_TOAST_TIMEOUT = 3000;

function showCartToast(message) {
    let container = document.querySelector('.cart-toast-container');
    if (!container) {
        container = document.createElement('div');
        container.className = 'cart-toast-container';
        document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = '<span class="cart-toast__icon" aria-hidden="true"></span>'
        + '<span class="cart-toast__text"></span>'
        + '<span class="cart-toast__progress"></span>';
    toast.querySelector('.cart-toast__text').textContent = message;
    toast.querySelector('.cart-toast__progress').style.animationDuration = CART_TOAST_TIMEOUT + 'ms';
    container.appendChild(toast);

    setTimeout(function () {
        toast.classList.add('cart-toast--hide');
        // icon and progress bar animations bubble too, remove only after own hide animation
        toast.addEventListener('animationend', function (event) {
            if (event.target === toast) {
                toast.remove();
            }
        });
    }, CART_TOAST_TIMEOUT);
}

function showAddedToCartToast() {
    showCartToast(addedToCartTexts[lang] || addedToCartTexts['ro']);
}

// Module scope: expose for other scripts (app/js/retail-functions.js rrAddToBasket)
globalThis.showAddedToCartToast = showAddedToCartToast;

$(document).ready(function (e) {
    $(document).on('click', '.check_color_and_size', function(event){
        event.preventDefault();
        let _self = $(this);
        let _alternative = _self.data('alternative');
        const box = $(this).closest('.bv_data');
        const articol = box.data('articol');
        const id = box.data('id');
        //console.log(articol, id, _self, _alternative);
        myCheckColorAndSize(articol, id, _self, _alternative, event.target);
    });

    // +/- в корзине обрабатывает app/js/cart_checkout.js (/{cos|korzina}/add/ и /{cos|korzina}/decrement/)

    $(document).on('click', '.add_to_cart', function(event){
        event.preventDefault();
        const box = $(this).closest('.bv_data');
        const articol = box.data('articol');
        const id = box.data('id');
        const color = box.data('color');
        const size = box.data('size');
        const choose_color = $('.prod_color');
        const choose_size = $('.prod_size');

        if (color == null) {
            choose_color.addClass('animated shake');
            choose_color.closest('.product__func').find(".tooltip .info").css('visibility', 'visible');
            setTimeout(function () {
                choose_color.removeClass('animated shake');
            }, 1000);
        }

        if (size == null) {
            choose_size.addClass('animated shake');
            choose_size.closest('.product__func').find(".tooltip .info").css('visibility', 'visible');
            setTimeout(function () {
                choose_size.removeClass('animated shake');
            }, 1000);
        }

        if (color == null || size == null) {
            let width = $(window).width();
            if(width < 992) {
                $('html, body').animate({scrollTop: (choose_color.offset().top - ($('.header2').height() * 2))}, 500);
            }
            return false;
        }

        myAddToCart(articol, id, color, size, 1);
    });

    function myCheckColorAndSize(articol, id, _self = null, _alternative = null, eventTarget = null) {
        $.post('/'+lang+'/ajax/check_color_and_size/', {articol: articol, id: id}, function (result) {
            console.log('result', result);
            let data = JSON.parse(result);

            if(data.status) {
                if(_self !== null) {
                    _self.addClass('uk-active');
                    _self.removeClass('btn').addClass('btn4').val(_alternative);
                }
                myAddToCart(articol, id, data.color, data.size, 1, '', eventTarget);
            }
        });
    }
    // «В корзину»: POST /{lang}/{cos|korzina}/add/ → RetailRocketCart::increment (добавляет товар или +1)
    function myAddToCart(articol, id, color, size, qty, change= '', eventTarget = null) {
        $('.block-product[data-id="'+id+'"]').addClass('loading');
        $.post('/'+lang+'/'+urls[lang]+'/add/', {id: id, color: color, size: size}, function (data) {
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }

            $('.block-product[data-id="'+id+'"]').removeClass('loading');
            if (!data || !data.success) {
                return;
            }

            // GA4 add_to_cart: данные товара берём из разметки карточки
            const ecomItem = document.querySelector(`.ecommerce-list-data[data-ecom_id='${id}']`);
            if (ecomItem && typeof AddToCart === 'function') {
                const dataset = ecomItem.dataset;
                AddToCart({
                    'item_name': dataset.ecom_name,
                    'item_id': dataset.ecom_id,
                    'item_category': dataset.ecom_category,
                    'price': dataset.ecom_price,
                    'discount': dataset.ecom_discount,
                    'item_list_id': dataset.ecom_list_id,
                    'item_list_name': dataset.ecom_list_name,
                    'index': dataset.ecom_index,
                });
            }

            $(".cart_num").attr("data-count", data.cart_qty).css('z-index', 99);
            $(".cart_num").addClass('blink');
            setTimeout(function () {
                $(".cart_num").removeClass('blink');
            }, 500);
            $(".qty").text(data.cart_qty);
            $(".total").text(data.cart_total);

            showAddedToCartToast();

            (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
                try {
                    rrApi.addToBasket(data.product_id, {
                        // Default stockId 208679 | Интернет-магазин
                        'stockId': '208679'
                    });
                } catch (e) {}
            })
        });
    }
});
